import gql from 'graphql-tag';

// Local data queries
export const AUTH_STATUS = gql`
  query AuthStatus {
    authStatus @client {
      isAuthenticated
      currentUser
    }
  }
`;
